import script from "./RoadmapExport.vue?vue&type=script&setup=true&lang=js"
export * from "./RoadmapExport.vue?vue&type=script&setup=true&lang=js"

import "./RoadmapExport.vue?vue&type=style&index=0&id=900aa64a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-900aa64a"]])

export default __exports__